import React from 'react';
import classnames from 'classnames';
import { compact } from 'lodash';

import { LogoGalleryComponentFragment } from '../../../../graphql.schema';
import Image from '../../Image';

import * as styles from './StrapiLogoGallery.module.scss';

export const StrapiLogoGallery: React.FC<LogoGalleryComponentFragment> = ({ logoTitle, logos }) => {
  return (
    <div className={styles.logoGallery}>
      <div className="columns">
        <div className="column is-8 is-offset-2">
          <h2 className="title is-2 has-text-centered">{logoTitle}</h2>
        </div>
      </div>
      <div className={styles.grid}>
        {compact(logos).map(({ name, image }) => (
          <div className={styles.imageWrapper} key={name}>
            <Image image={image} className={styles.logoImage} loading="lazy" />
            <p className={classnames(styles.logoName, 'black-4')}>{name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
